// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ClaimLabor from '@deere/cps-it.warranty-model-factory/lib/claim-item-labor';
import ClaimVsrMessage from '@deere/cps-it.warranty-model-factory/lib/claim-vsr-message';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LaborsPanel from '../../../shared/components/labors-panel';

function handleLaborCreate() {

    this.actions.addLabor();

}

function handleLaborDeletion(index) {

    this.actions.deleteLabor(index);

}

function handleLaborHoursChange(index, hours) {

    this.actions.changeLaborProperty(index, hours, 'laborHours');

}

function handleLaborCommentsChange(index, hours) {

    this.actions.changeLaborProperty(index, hours, 'spgJobCode');

}

function handleLaborTechIdChange(index, techId) {

    this.actions.changeLaborProperty(index, techId, 'techId');

}

function handleLaborLocationChange(index, partNumber) {

    this.actions.changeLaborLocation(index, partNumber);

}

function handleLaborTypeChange(index, laborType) {

    this.actions.changeLaborType(index, laborType);

}

const LaborPanelContainer = props =>
    <LaborsPanel
        errors={props.errors}
        isEditable={props.isEditable}
        laborLocations={props.laborLocations}
        laborTypes={props.laborTypes}
        labors={props.labors}
        onCreate={props::handleLaborCreate}
        onDelete={props::handleLaborDeletion}
        onHoursChange={props::handleLaborHoursChange}
        onLaborCommentsChange={props::handleLaborCommentsChange}
        onLocationChange={props::handleLaborLocationChange}
        onTechIdChange={props::handleLaborTechIdChange}
        onTypeChange={props::handleLaborTypeChange}
    />;

LaborPanelContainer.displayName = 'LaborPanelContainer';
LaborPanelContainer.propTypes = {
    actions: PropTypes.object.isRequired,
    errors: PropTypes.arrayOf(PropTypes.instanceOf(ClaimVsrMessage)),
    isEditable: PropTypes.bool.isRequired,
    laborLocations: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    laborTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    labors: PropTypes.arrayOf(PropTypes.instanceOf(ClaimLabor)).isRequired
};

export default LaborPanelContainer;



// WEBPACK FOOTER //
// ./src/claim/track/components/labors-panel/labor-panel-container.js